// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"780e6689","44":"31383f90","53":"f3cff9c3","122":"1d9dff66","156":"3cf6e8b0","173":"9f6381ce","198":"d450f437","428":"f5cf8a79","429":"891980b2","638":"5a3bc483","797":"fc6f6d0b","819":"3e79376e","948":"7c883244"}[chunkId] + ".chunk.js";
};